module.exports = __webpack_public_path__ + "img/icon6.91a47c5d.png";